const SearchIcon = ({ size = 14, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M9.91666 9.9165L12.25 12.2498"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.0833 6.41667C11.0833 3.83934 8.99401 1.75 6.41667 1.75C3.83934 1.75 1.75 3.83934 1.75 6.41667C1.75 8.99401 3.83934 11.0833 6.41667 11.0833C8.99401 11.0833 11.0833 8.99401 11.0833 6.41667Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const PhoneIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M6.1055 3.80815L5.83707 3.20417C5.66155 2.80925 5.57379 2.61179 5.44254 2.46067C5.27805 2.27129 5.06364 2.13196 4.82378 2.05857C4.63239 2 4.4163 2 3.98414 2C3.35194 2 3.03584 2 2.77048 2.12153C2.45791 2.26468 2.17562 2.57552 2.06315 2.9004C1.96767 3.17619 1.99502 3.45962 2.04972 4.02647C2.63194 10.0601 5.93988 13.3681 11.9735 13.9503C12.5404 14.005 12.8238 14.0323 13.0996 13.9369C13.4245 13.8244 13.7353 13.5421 13.8785 13.2295C14 12.9641 14 12.6481 14 12.0159C14 11.5837 14 11.3676 13.9414 11.1762C13.868 10.9363 13.7287 10.7219 13.5393 10.5575C13.3882 10.4262 13.1908 10.3385 12.7958 10.1629L12.1918 9.89447C11.7642 9.7044 11.5503 9.6094 11.333 9.58873C11.125 9.56893 10.9154 9.59813 10.7207 9.67393C10.5173 9.75313 10.3376 9.90293 9.97797 10.2025C9.6201 10.5008 9.44117 10.6499 9.2225 10.7298C9.02864 10.8006 8.77237 10.8269 8.56824 10.7967C8.3379 10.7628 8.16157 10.6686 7.80884 10.4801C6.7115 9.89367 6.10635 9.28853 5.51991 8.19113C5.33143 7.83847 5.23718 7.66207 5.20324 7.4318C5.17316 7.2276 5.19938 6.97133 5.2702 6.77753C5.35008 6.55885 5.49921 6.37991 5.79746 6.022C6.09708 5.66245 6.24689 5.48268 6.3261 5.27927C6.4019 5.08463 6.43108 4.87493 6.4113 4.66699C6.39063 4.44968 6.29558 4.23584 6.1055 3.80815Z"
      stroke="currentColor"
      strokeLinecap="round"
    />
  </svg>
);

const EmailIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M1.33203 4L5.94071 6.61131C7.63976 7.574 8.35763 7.574 10.0567 6.61131L14.6654 4"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      d="M1.34254 8.98439C1.38612 11.0281 1.40792 12.0499 2.162 12.8069C2.91608 13.5639 3.96558 13.5902 6.06458 13.6429C7.35823 13.6755 8.63916 13.6755 9.93283 13.6429C12.0318 13.5902 13.0813 13.5639 13.8354 12.8069C14.5895 12.0499 14.6113 11.0281 14.6548 8.98439C14.6689 8.32725 14.6689 7.67405 14.6548 7.01692C14.6113 4.97322 14.5895 3.95138 13.8354 3.19443C13.0813 2.43747 12.0318 2.41111 9.93283 2.35837C8.63916 2.32586 7.35823 2.32586 6.06458 2.35836C3.96558 2.41109 2.91608 2.43746 2.162 3.19442C1.40791 3.95137 1.38612 4.97322 1.34254 7.01692C1.32852 7.67405 1.32853 8.32725 1.34254 8.98439Z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
  </svg>
);
const DropDownIcon = ({ size = 14, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path d="M5 7.50004L10 12.5L15 7.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CalendarIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#calendarClip)">
      <path
        d="M12 1.33252V2.66585M4 1.33252V2.66585"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.99625 8.66748H8.00225M7.99625 11.3341H8.00225M10.6599 8.66748H10.6659M5.33258 8.66748H5.33856M5.33258 11.3341H5.33856"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.33258 5.33252H13.6659"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66742 8.16213C1.66742 5.25729 1.66742 3.80485 2.50217 2.90243C3.33691 2 4.68041 2 7.36742 2H8.63409C11.3211 2 12.6646 2 13.4994 2.90243C14.3341 3.80485 14.3341 5.25729 14.3341 8.16213V8.50453C14.3341 11.4094 14.3341 12.8618 13.4994 13.7643C12.6646 14.6667 11.3211 14.6667 8.63409 14.6667H7.36742C4.68041 14.6667 3.33691 14.6667 2.50217 13.7643C1.66742 12.8618 1.66742 11.4094 1.66742 8.50453V8.16213Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 5.33252H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="calendarClip">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);
const PercentageIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M2.66602 13.3341L13.3327 2.66748"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.5112 3.15564C6.16207 3.80651 6.16207 4.86179 5.5112 5.51266C4.86032 6.16354 3.80504 6.16354 3.15417 5.51266C2.5033 4.86179 2.5033 3.80651 3.15417 3.15564C3.80504 2.50476 4.86032 2.50476 5.5112 3.15564Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12.8452 10.4882C13.4961 11.139 13.4961 12.1943 12.8452 12.8452C12.1943 13.4961 11.139 13.4961 10.4882 12.8452C9.83728 12.1943 9.83728 11.139 10.4882 10.4882C11.139 9.83728 12.1943 9.83728 12.8452 10.4882Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
const ClockIcon = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <g clipPath="url(#clip0_119_3638)">
      <path
        d="M8.00065 14.6668C11.6825 14.6668 14.6673 11.6821 14.6673 8.00016C14.6673 4.31826 11.6825 1.3335 8.00065 1.3335C4.31875 1.3335 1.33398 4.31826 1.33398 8.00016C1.33398 11.6821 4.31875 14.6668 8.00065 14.6668Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M8 5.3335V8.00016L9.33333 9.3335"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_119_3638">
        <rect width={16} height={16} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const CloudUploadIcon = ({ size = 28, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M21.9799 8.17751C21.0065 3.4469 16.3824 0.401132 11.6518 1.37456C7.60105 2.20812 4.68809 5.76531 4.66951 9.90082C4.66951 10.0979 4.67765 10.2996 4.69514 10.513C1.81339 10.818 -0.275457 13.4014 0.0295794 16.2831C0.312316 18.9542 2.5665 20.9805 5.25247 20.9778H5.86462C5.85063 20.7843 5.83549 20.5919 5.83549 20.3948C5.83549 16.2091 9.22871 12.8158 13.4145 12.8158C17.6003 12.8158 20.9935 16.2091 20.9935 20.3948C20.9935 20.5919 20.9783 20.7842 20.9643 20.9778H21.5765C25.1144 20.9875 27.9903 18.1273 28 14.5893C28.0092 11.1946 25.3686 8.38203 21.9799 8.17751Z"
      fill="#D3E0EF"
    />
    <path
      d="M13.413 26.8084C16.9548 26.8084 19.826 23.9372 19.826 20.3954C19.826 16.8536 16.9548 13.9824 13.413 13.9824C9.87119 13.9824 7 16.8536 7 20.3954C7 23.9372 9.87119 26.8084 13.413 26.8084Z"
      fill="#0F345E"
    />
    <path
      d="M13.415 24.4765C13.0931 24.4765 12.832 24.2154 12.832 23.8935V16.8975C12.832 16.5755 13.0931 16.3145 13.415 16.3145C13.737 16.3145 13.9981 16.5755 13.9981 16.8975V23.8935C13.998 24.2154 13.737 24.4765 13.415 24.4765Z"
      fill="#FAFAFA"
    />
    <path
      d="M15.7471 19.8118C15.6705 19.8119 15.5946 19.797 15.5238 19.7678C15.453 19.7385 15.3886 19.6957 15.3344 19.6415L13.4151 17.7211L11.4959 19.6415C11.2643 19.8652 10.8952 19.8588 10.6715 19.6272C10.5665 19.5185 10.5078 19.3733 10.5078 19.2222C10.5078 19.0711 10.5665 18.9259 10.6715 18.8172L13.0035 16.4851C13.2312 16.2576 13.6002 16.2576 13.8279 16.4851L16.1599 18.8172C16.3872 19.0452 16.3867 19.4143 16.1586 19.6416C16.0494 19.7506 15.9014 19.8118 15.7471 19.8118Z"
      fill="#FAFAFA"
    />
  </svg>
);

const SlashEyeIcon = ({size=18,...rest}) => (
  <svg
    width={size}
    {...rest}
    height={size}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5792 11.5793C15.75 10.5 16.5 9 16.5 9C15.375 6.75 12.5169 3.75 9 3.75C8.31915 3.75 7.67205 3.86607 7.0637 4.0637M12.75 13.064C11.6743 13.7526 10.4095 14.25 9 14.25C5.48309 14.25 2.625 11.25 1.5 9C1.5 9 2.625 6.75 4.875 5.18885"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M7.39339 7.5C6.99587 7.8975 6.75 8.44673 6.75 9.05333C6.75 10.2665 7.73347 11.25 8.94667 11.25C9.55327 11.25 10.1025 11.0042 10.5 10.6066"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
    <path
      d="M2.25 2.25L15.75 15.75"
      stroke="currentcolor"
      strokeWidth="1.5"
      strokeLinecap="square"
    />
  </svg>
);

const EyeIcon = ({size=18,...rest}) => (
  <svg
    width={size}
    height={size}
    {...rest}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.25 9C11.25 7.75732 10.2427 6.75 9 6.75C7.75732 6.75 6.75 7.75732 6.75 9C6.75 10.2427 7.75732 11.25 9 11.25C10.2427 11.25 11.25 10.2427 11.25 9Z"
      stroke="currentcolor"
      strokeWidth="1.5"
    />
    <path
      d="M9 3.75C13.1421 3.75 16.5 9 16.5 9C16.5 9 13.1421 14.25 9 14.25C4.85786 14.25 1.5 9 1.5 9C1.5 9 4.85786 3.75 9 3.75Z"
      stroke="currentcolor"
      strokeWidth="1.5"
    />
  </svg>
);
export {
  SearchIcon,
  PhoneIcon,
  EmailIcon,
  DropDownIcon,
  CalendarIcon,
  PercentageIcon,
  ClockIcon,
  CloudUploadIcon,
  SlashEyeIcon,
  EyeIcon,
};
